import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import Link from '@material-ui/core/Link';

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    padding: 0 !important;
    width: 80%;
    min-width: 80%;
    max-width: 80%;
  }
`;

export const StyledLink = styled(Link)`
  text-decoration: none !important;
`;